import { render, staticRenderFns } from "./ApmsBasicToolInfo.vue?vue&type=template&id=0fff0bac&scoped=true&"
import script from "./ApmsBasicToolInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicToolInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff0bac",
  null
  
)

export default component.exports